import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-close\"><path d=\"M13.034 13.008c.303-.303.32-.8.03-1.09l-4.93-4.93 4.893-4.895a.793.793 0 00.007-1.1.788.788 0 00-1.101.006L7.039 5.893 2.103.958c-.29-.29-.787-.274-1.09.029-.308.308-.32.8-.029 1.09L5.92 7.012l-4.894 4.894c-.297.297-.314.806-.013 1.107.296.296.81.285 1.107-.012l4.894-4.894 4.93 4.93c.29.29.782.279 1.09-.03z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol